// extracted by mini-css-extract-plugin
export default {"container":"MessagesList_container__qPjOW"};